var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAngleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39254 7.99568C8.39254 7.77979 8.30733 7.5639 8.14544 7.4171L1.38845 0.733161C1.24359 0.586356 1.05614 0.5 0.843117 0.5C0.400036 0.5 0.0592041 0.836787 0.0592041 1.28584C0.0592041 1.50173 0.144412 1.70035 0.280745 1.84715L6.48388 7.99568L0.280745 14.1528C0.144412 14.291 0.0592041 14.4896 0.0592041 14.7142C0.0592041 15.1632 0.400036 15.5 0.843117 15.5C1.05614 15.5 1.24359 15.4136 1.39697 15.2668L8.14544 8.5829C8.30733 8.41883 8.39254 8.22021 8.39254 7.99568Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngleRight);
export default __webpack_public_path__ + "static/media/icon-angle-right.4589c8cfd4d60fa0fea2eacbb28d0d54.svg";
export { ForwardRef as ReactComponent };